import { render, staticRenderFns } from "./SearchTabs.vue?vue&type=template&id=00f436ea&scoped=true&"
import script from "./SearchTabs.vue?vue&type=script&lang=js&"
export * from "./SearchTabs.vue?vue&type=script&lang=js&"
import style0 from "./SearchTabs.vue?vue&type=style&index=0&id=00f436ea&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00f436ea",
  null
  
)

export default component.exports